import * as React from 'react';

import { useEditingTableCellName } from 'af-root/hooks/useEditingTableCellName';

export function useShouldCellBeRegistered(name: string) {
	const editingCellName = useEditingTableCellName();
	const [wasEdited, setWasEdited] = React.useState(false);

	const shouldBeRegistered = React.useMemo(() => {
		if (wasEdited) return true;

		const _isInEdit = editingCellName?.editingTableCellName === name;
		if (_isInEdit) {
			setWasEdited(true);
		}
		return _isInEdit;
	}, [editingCellName, name, wasEdited]);

	const exitEditMode = React.useCallback(() => {
		editingCellName?.setEditingTableCellName(null);
	}, [editingCellName]);

	const reset = React.useCallback(() => {
		exitEditMode();
		setWasEdited(false);
	}, [exitEditMode]);

	const rv = React.useMemo(() => ({ shouldBeRegistered, exitEditMode, reset }), [exitEditMode, shouldBeRegistered, reset]);

	return rv;
}
